import styled, { css } from 'styled-components';

export const StickyTrack = styled.div`
  height: 100%;
  position: relative;
`;

type StickyElementProps = {
  position: 'middle' | 'bottom' | 'top';
  headerHeight: number;
  topMargin: number;
};
export const StickyElement = styled.div<StickyElementProps>`
  z-index: 4; /* needs to be higher than the Tabs on the product page */

  ${props =>
    props.position === 'middle' &&
    css`
      position: fixed;
      top: ${props.headerHeight + props.topMargin}px;
    `}

  ${props =>
    props.position === 'bottom' &&
    css`
      position: absolute;
      bottom: 0;
    `}

  @supports (position: sticky) {
    position: sticky;
    top: ${props => props.headerHeight + props.topMargin}px;
  }
`;
